export default function recolor_svg(svg, to_color, from_color='#FFFFFF00'){
  return svg.replace(`="${from_color}"`, `="${to_color}"`);
}